const getApiBase = () => {
  if (process.env.REACT_APP_API_BASE) {
    return process.env.REACT_APP_API_BASE;
  }
  if (typeof window === "undefined") {
    return "http://127.0.0.1:5000";
  }
  const { hostname, protocol, origin } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return `${protocol}//${hostname}:5000`;
  }
  return origin || `${protocol}//${hostname}`;
};

export default getApiBase;
